import React from "react";
import VirtualHomeImg from "../assets/images/virtual-home.svg";
import { Link } from "react-router-dom";
import PlayIcon from "../assets/images/play-icon.svg";
import DealHomeIcom from "../assets/images/deal-home.svg";
const VirtualHome = () => {
  return (
    <>
      <div className="virtual-space">
        <div className="virtual-home">
          <div className="virtual-h-left">
            <img className="virtual-h-img" src={VirtualHomeImg} alt="" />
            <div className="v-h-tour play-position">
              <div className="play-icon-m">
                <img src={PlayIcon} alt="" />
              </div>
              <div className="">
                <h3 className="v-h-tour-title">Virtuell hemvisning</h3>
                <p className="virtual-text-p mb-0">
                  vi ger dig en virtuell hemvisning gratis
                </p>
              </div>
            </div>
            <div className="v-h-tour deal-position">
              <div className="deal-home-icon">
                <img src={DealHomeIcom} alt="" />
              </div>
              <div className="">
                <h3 className="v-h-tour-title">Hitta de bästa erbjudandena</h3>
                <p className="virtual-text-p mb-0">
                  vi ger dig virtuell hemrenovering
                </p>
              </div>
            </div>
          </div>
          <div className="virtual-h-right">
            <h2 className="virtual-h-right-title">
              Förstklassig renovering i Söder Renovering
            </h2>
            <p className="virtual-text">
              Fundera du på att renovera din lägenhet, radhus eller villa? Letar
              du efter en byggare med lång erfarenhet av att leverera projekt
              med elegant utförande och högkvalitativa material? Då är vi rätt
              företag för dig! När du anlitar oss för din renovering i Söder
              Renovering kan du alltid räkna med ett resultat av högsta klass.
              <br />
              <br />
              Varför välja oss? Vi är ett komplett företag som erbjuder allt du
              behöver för din renovering – på ett och samma ställe. Hos oss
              hittar du erfarna elektriker, rörmokare, snickare, plattsättare,
              målare och många fler. Detta innebär att du slipper bekymret med
              att koordinera flera yrkesgrupper – vi sköter hela projektet åt
              dig, från start till mål. Vi arbetar med precision och kvalitet
              för att säkerställa att varje detalj blir perfekt, oavsett om det
              handlar om badrumsrenovering, köksrenovering eller andra projekt.
              <br />
              <br />
              Badrumsrenoveringar och mer Badrumsrenoveringar är ett av våra
              specialområden. Vi skräddarsyr lösningar efter dina behov och
              utför även renoveringar av bastu och tvättstugor. Med vår
              helhetslösning kan du känna dig trygg med att allt blir
              professionellt och noggrant utfört.
            </p>
            <div className="my-5">
              <Link to={"/services"} className="reg-btn">
                Gratis offert
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VirtualHome;
